import { Dialog } from '@mui/material';

export { default as DialogTitle } from './DialogTitle.component';
export { DialogActions, DialogContent, Dialog } from '@mui/material';

export type { DialogProps } from '@mui/material';

export * from './interfaces';
export * from './Dialog.styled';

export default Dialog;
